import { useState, useEffect } from 'react';
import styles from './styles.module.scss';

/**
 * Cookie Banner - Simple custom implementation with no library overhead
 * Completely controls cookie behavior without any hidden library cookies
 */
export default function CookieBanner({ onSave, isOpen, onManageClick }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(isOpen);
  }, [isOpen]);

  const handleAccept = () => {
    onSave({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true,
    });
    setIsVisible(false);
  };

  const handleDecline = () => {
    onSave({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
    });
    setIsVisible(false);
  };

  const handleManage = () => {
    if (onManageClick) {
      onManageClick();
    }
  };

  if (!isVisible) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <h3 className={styles.title}>We use cookies</h3>
        <p className={styles.description}>
          At Gravitas Recruitment Group, we use cookies and tracking technologies to enhance your experience, provide tailored recruitment opportunities, measure campaign performance, and understand how recruitment professionals use our platform.
        </p>
      </div>
      <div className={styles.actions}>
        <button className={styles.declineBtn} onClick={handleDecline}>
          I decline
        </button>
        <button className={styles.manageBtn} onClick={handleManage}>
          Change my preferences
        </button>
        <button className={styles.acceptBtn} onClick={handleAccept}>
          I agree
        </button>
      </div>
    </div>
  );
}
